

import React, { useEffect, useState } from 'react';
import { useForm, Controller } from 'react-hook-form';
import FingerprintJS from '@fingerprintjs/fingerprintjs'
import {
    CheckCircleFilled,
    LockOutlined,
    MailOutlined,
    UserOutlined
} from '@ant-design/icons';
 import { useDispatch } from 'react-redux';
import InspectionBtn from '@/components/InspectionBtn';
import { useAuth } from '@/hooks/useAuth';
import { useNavigate } from 'react-router-dom';
import Logo from "@/assets/inspections1.png"
import { Card, Input, Typography } from 'antd';
import axios from 'axios';
import { apiUrl } from '@/services/axios.config';

const VerifyEmail = ({ onToggle }) => {
    const {
        handleSubmit,
        control,
        formState: { errors },
    } = useForm();

    const dispatch = useDispatch()
    const { role, isAuthenticated } = useAuth();
    const navigate = useNavigate();
    const [verfied, setVerified] = useState(false);
    const [loading, setLoading] = useState(false)

    const onSubmit = async (data) => {
        setLoading(true)
        const resdata = await axios.post(`${apiUrl}/auth/verify`, { email: data?.email });
        if (resdata.data?.message === "Already Exist") {
            setLoading(false);
            navigate("/login")
        }
        if (resdata?.data?.message === "Verified") {
            setVerified(true)
            setLoading(false)

        }

    };


    useEffect(() => {
        if (isAuthenticated && role) {

            switch (role) {
                case "ADMIN":
                    navigate("/admin/dashboard", { replace: true });
                    break;
                case "USER":
                    navigate("/user/dashboard", { replace: true });
                    break;
                case "OWNER":
                    navigate("/manager/dashboard", { replace: true });
                    break;
                default:
                    navigate("/unauthorized", { replace: true });
            }
        }
    }, [role, isAuthenticated, navigate]);




    const handleFormSubmit = (e) => {
        e.preventDefault();
        handleSubmit(onSubmit)(e);

    };


    return (
        <div className="min-h-screen flex items-center justify-center   bg-gradient-to-r from-[#0087af] to-emerald-400py-12 px-4 sm:px-6 lg:px-8">
            <div className="max-w-4xl w-full">
                <div className="bg-white rounded-2xl shadow-2xl p-10">
                    <div className="flex justify-center items-center mb-6">
                        <img
                            src={Logo}
                            alt="Company Logo"
                            className="h-20 w-20 rounded object-contain"
                        />
                        <span className="text-[28px] font-extrabold tracking-tight bg-gradient-to-r from-[#0087af] to-[#00ae68] bg-clip-text text-transparent">
                            SpotFlash
                        </span>

                    </div>
                    {verfied ?
                        <div className="flex justify-center items-center   bg-gray-100">
                            <Card
                                className="w-full rounded-2xl"
                                bodyStyle={{ padding: "24px" }}
                            >
                                <h2 className="text-2xl font-semibold text-green-600 mb-2">
                                    <CheckCircleFilled /> User Verified
                                </h2>
                                <p className="text-gray-600 text-base">
                                    Please check your email to complete the registration process.
                                </p>
                            </Card>
                        </div> :
                        <>
                            <Typography.Title level={4} className="text-center flash-color  !font-bold text-gray-900">Create your account</Typography.Title>


                            <div>
                                <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-1">
                                    Email
                                </label>
                                <Controller
                                    name="email"
                                    control={control}
                                    rules={{
                                        required: "Email Required",
                                        pattern: {
                                            value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                                            message: "Invalid email address"
                                        }
                                    }}
                                    render={({ field }) => (
                                        <Input
                                            prefix={<MailOutlined className="me-2" />}
                                            placeholder="Email"
                                            {...field}
                                            size="large"
                                        />
                                    )}
                                />
                                {errors.email && <p className="text-red-500 text-sm mt-1">{errors.email.message}</p>}
                            </div>




                            {/* Submit Button */}
                            <div className="mt-8">
                                <InspectionBtn
                                    loading={loading}
                                    onClick={handleFormSubmit}
                                    className="w-full   rounded-md shadow-md text-white bg-teal-600 hover:bg-teal-700 transition transform hover:scale-[1.02] focus:ring-2 focus:ring-offset-2 focus:ring-teal-500"
                                >
                                    Verfiy Email
                                </InspectionBtn>
                            </div>

                            {/* Switch to Sign in */}
                            <div className="text-center mt-6">
                                <p className="text-sm text-gray-600">
                                    Already have an account?{" "}
                                    <button
                                        type="button"
                                        className="font-medium text-teal-600 hover:text-teal-500 underline"
                                    >
                                        Sign in
                                    </button>
                                </p>
                            </div>
                        </>
                    }
                </div>

            </div>

        </div>

    );
};

export default VerifyEmail;